export const managerPrices = {
  page: {
    title: "Precios de la plataforma",
    subtitle: "Listado de precios para los planes de la plataforma",
  },
  table: {
    name: "Nombre",
    type: "Tipo",
    price: "Precio",
    created: "Creado",
    edit: "Editar precio",
  },
  form: {
    title: "Actualizar precio",
    planName: "Nombre del plan",
    planType: "Tipo de plan",
    annual: "Anual",
    monthly: "Mensual",
    cancel: "Cancelar",
    save: "Guardar",
  },
  toast: {
    saved: "Registrado correctamente",
    error: "Error de solicitud",
  },
};
